import { Observable } from 'rxjs';
import AxiosSubscriber from '../../factory/AxiosSubscriber';
import { baseURLEndpoint } from '../../shared/constant';

export class ClientDetailAPI {
  constructor() {
    this.subscription = null;
  }

  subscribe(next, complete, error, token = null) {
    const userToken = token === null ? localStorage.getItem("token") : token;
    const httpConfig = {
      url: `${baseURLEndpoint}/r/profile`,
      method: 'get',
      headers: {
        'Authorization': `Bearer ${userToken}`
      }
    };

    let observable$ = new Observable((observer) => {
      return new AxiosSubscriber(observer, httpConfig, false);
    });

    this.subscription = observable$.subscribe({
      next: next,
      complete: complete,
      error: error
    });
  }

  unsubscribe() {
    if (this.subscription !== undefined && this.subscription !== null) {
      this.subscription.unsubscribe();
    }
  }
}